import {GrammarlyButton} from '@grammarly/editor-sdk-react';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {useAppSelector} from '../../helpers/appReduxHelpers';
import {getIsGrammarlyAllEnabled} from './grammarlySelectors';

interface InlineGrammarlyButtonProps {
  isHidden?: boolean;
}

/*
 * Style.
 */

interface StyledGrammarlyInlineButtonProps {
  $isHidden?: boolean;
}

const StyledGrammarlyInlineButtonWrapperDiv = styled.div<StyledGrammarlyInlineButtonProps>`
  padding: 2px 10px 10px 0;
  overflow: hidden;
  position: sticky;
  bottom: 0;
  right: 0;

  width: fit-content;
  align-self: flex-end;

  ${(p) =>
    p.$isHidden &&
    css`
      display: none;
    `}
`;

/*
 * Component.
 */

export const InlineGrammarlyButton: FC<InlineGrammarlyButtonProps> = (props) => {
  const isGrammarlyAllEnabled = useAppSelector(getIsGrammarlyAllEnabled);

  if (!isGrammarlyAllEnabled) {
    return null;
  }
  return (
    <StyledGrammarlyInlineButtonWrapperDiv $isHidden={props.isHidden}>
      <GrammarlyButton />
    </StyledGrammarlyInlineButtonWrapperDiv>
  );
};
